var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.3 512.1",
    enableBackground: "new 0 0 473.3 512.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294,512.1c0.3,0,0.7,0,1,0c-4.8-1.7-12.3-0.5-18-1c0,0.3,0,0.7,0,1C282.7,512.1,288.3,512.1,294,512.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,235.1c-0.3,0-0.7,0-1,0c0,66.7,0,133.3,0,200c0.3,0,0.7,0,1,0C1,368.4,1,301.7,1,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,0.1c-38.5-2.1-54.5,47.7-60.2,83.8c-0.7,5-2.3,9.5-4.9,13.5c-23.6,35.8-50.2,68.7-80,98.7v0.5 c-28.7,0.4-57.3,0.4-86,0.5c-20.4,2.6-33,12.9-38,31c0,62,0,124,0,186c-2.5,27.7,4.4,56.2,37,57.9c30.7,0.1,61.3,0.2,92,0.6v0.5 c55.6,13.7,108.2,37.2,165,39c15.3,0,30.7,0,46,0c0-0.3,0-0.7,0-1c52.5,1,91-36,90-88c0.3,0,0.7,0,1,0c0-1.3,0.1-2.7,0-4 c12.2-13,18.3-33,18-58c-1.6-2.1-0.6-7-1-10c0.3,0,0.7,0,1,0c0-0.7,0-1.3,0-2c6.8-10,11-25.5,10-39c0.3,0,0.7,0,1,0 c-0.2-8.9-1-17.6-2-26c8.2-11,14.1-28.4,13-44c0.3,0,0.7,0,1,0c-5.7-85.8-66.2-82.8-132-83c5.8-15.3,14.7-34.6,13-54 c0.3,0,0.7,0,1,0c0-4,0-8,0-12C354.5,36.5,324.8,1.6,270,0.1 M315,84.1c0.7,6.1,2.2,15.2,0,22c-7.1,30.9-24.7,59.4-28,90 c36,0,72,0.2,108,0.5v0.5c25,2.3,42.9,22.7,38,46c-1.1,16.3-8.6,27.5-22,32c5.1,7.6,13.4,29,10,39c-1.7,12.3-7,22.4-15,29 c1.9,10,7.4,19.7,4,30c-2,14-8.7,24.7-19,31c-1.5,8.4,4.4,13.4,1,21c-1.7,29.7-18.2,45.9-49,47v0.5c-46.9,3-95.8-3.3-137.4-19.1 c-25.7-9.4-57.4-18.9-86.6-20.4c-4.2-65,0.4-131.7-1-197c21.1,1.9,40.5-12.4,52.4-26.9c23.5-31.7,52.3-58.9,70.2-94.8 c11.1-21.8,11.6-53.3,24.4-73.3C297.3,38,314.2,52.9,315,84.1 M67.8,396.7c0.8,0.2,1.9,0.4,3.2,0.4c11.1,7.7,7.8,23.8-1,34 c-8.9,3.7-16,2.2-23-2C31.3,414.7,43.9,387.8,67.8,396.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421,314.1c2.1-2.8,0.8-7.9,0-10C421,307.4,421,310.7,421,314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343,472.1c-19.3,0-38.7,0-58,0c18.5,1.2,37.8,1.3,58,0.5V472.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392,415.1c0,3.3,0,6.7,0,10C394.1,422.3,392.8,417.1,392,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410,372.1c0,0.3,0,0.7,0,1c2.1-4.2,0.8-10.6,0-14C410,363.4,410,367.7,410,372.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394,197.1c0.3,0,0.7,0,1,0v-0.5c-36-0.3-72-0.5-108-0.5C321.8,197.2,357.5,197.6,394,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433,229.1c0,4.7,0,9.3,0,14C435.1,238.9,433.8,232.5,433,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136,434.1c-4.4-1.7-11.6-0.5-17-1C123.7,434.3,129.8,434.5,136,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,237.1c0-0.3,0-0.7,0-1c-0.3,0-0.7,0-1,0c1.4,65.3-3.2,132,1,197C119,367.7,119,302.4,119,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130,236.6c0,0,0-0.2,0-0.5c-3.7,0-7.3,0-11,0c0,0.3,0,0.7,0,1C122.7,237.1,126.3,236.9,130,236.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315,84.1c0,7.3,0,14.7,0,22C317.2,99.3,315.7,90.2,315,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350,512.1c0.3,0,0.7,0,1,0c0-0.3,0-0.7,0-1c-3.3,0-6.6,0-10,0c0,0.3,0,0.7,0,1 C344,512.1,347,512.1,350,512.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,1.1c0-0.3,0-0.7,0-1c-3.3,0-6.6,0-10,0C272.3,1.4,276.2,1.5,280,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431,433.1c1.4-2.2,1.4-6.2,1-10c-0.3,0-0.7,0-1,0C431,426.4,431,429.7,431,433.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,351.1c-0.3,0-0.7,0-1,0c0.4,3-0.6,7.9,1,10C450,357.7,450,354.4,450,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460,320.1c1.4-2.2,1.4-6.2,1-10c-0.3,0-0.7,0-1,0C460,313.4,460,316.7,460,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403,158.1v-0.5c-20.7-0.3-41.3-0.5-62-0.5C360.8,158.3,381.6,158.5,403,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473.1,241.1c0-0.3-0.1-0.7-0.1-1c-0.3,0-0.7,0-1,0c0,3.3,0,6.7,0,10C473.2,247.9,473.5,244.9,473.1,241.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129,473.1c0.3,0,0.7,0,1,0v-0.5c-30.3-0.3-60.7-0.5-91-0.5C68.2,473.2,98.2,473.6,129,473.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,196.1c-28.3,0-56.7,0-85,0c0,0.3,0,0.7,0,1c28.3,0,56.7-0.2,85-0.5V196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355,103.1c-0.3,0-0.7,0-1,0c0,3.3,0,6.7,0,10C355.4,110.8,355.4,106.8,355,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.5,91c0,0,0.2,0,0.5,0c0.4-3.8,0.4-7.8-1-10C354,84.4,354.2,87.7,354.5,91z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcon);
export default __webpack_public_path__ + "static/media/social_media_icon.c215656e.svg";
export { ForwardRef as ReactComponent };